/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-use-before-define */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaidProductDetails } from "../../shared/interfaces/model/tenant.interface";
import { Product } from "../../shared/interfaces/model/product.interface";
import Button from "../../shared/components/button/button";
import { JWT_TYPE } from "../../../utils/userUtils";
import DetailProduct from "./detailProduct";
import { isCurrentDateEqualOrLessThanGivenDate } from "../../../utils/dateUtils";

interface ProductActionsProps {
  paidProductDetails: PaidProductDetails[];
  productList: Product[];
  userInfo: JWT_TYPE;
  userRole: number;
  productMap: Map<string, string>;
}
const ProductActions: React.FC<ProductActionsProps> = ({
  paidProductDetails,
  productList,
  userInfo,
  userRole,
  productMap,
}) => {
  const navigate = useNavigate();
  const [isPopupOpen, setPopupOpen] = useState(false); // Stato per il pop-up
  const [isChecked, setIsChecked] = useState(false); // Stato per la checkbox
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null); // Stato per il prodotto selezionato
  const [selectedPaidProduct, setSelectedPaidProduct] =
    useState<PaidProductDetails | null>(null); // Stato per paidProduct

  const goToDetailPage = (
    product: Product,
    paidProductInfo: PaidProductDetails
  ) => {
    navigate(`/detailProduct/${product.appCode}`, {
      state: { product, paidProductInfo },
    });
  };

  const goToCheckout = (
    product: Product,
    paidProductInfo: PaidProductDetails
  ) => {
    navigate(`/private/checkoutPage/${product.appCode}`, {
      state: { product, paidProductInfo },
    });
  };

  const openAppPage = (url: string) => {
    const finalUrl = new URL(url);
    const token = window.localStorage.getItem("token");
    finalUrl.searchParams.set("token", token || "");
    window.open(finalUrl, "_blank");
  };

  const handlePayNowClick = (
    product: Product,
    paidProductInfo: PaidProductDetails
  ) => {
    // Apri il pop-up e salva il prodotto selezionato
    setSelectedProduct(product);
    setSelectedPaidProduct(paidProductInfo);
    setPopupOpen(true);
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
    setIsChecked(false);
  };

  const handleContinue = () => {
    // if (selectedProduct && selectedPaidProduct) {
    // Esegui il redirect solo se la checkbox è accettata
    goToCheckout(
      selectedProduct as Product,
      selectedPaidProduct as PaidProductDetails
    );
    setPopupOpen(false);
    // }
  };

  const getActionsButtons = (item: Product, isAdmin?: boolean) => {
    let isDetailButton;
    let isOpenAppButton;
    let IsPayNowButton = false;
    const hasPaidProduct = paidProductDetails.find(
      (paidItem) => paidItem.productAppCode === item.appCode
    );
    console.log("hasPaidProduct  ========>", hasPaidProduct);
    if (hasPaidProduct) {
      if (hasPaidProduct.paymentStatus === "Paid") {
        isDetailButton = true;
        if (
          isCurrentDateEqualOrLessThanGivenDate(hasPaidProduct.expireDate || "")
        ) {
          isOpenAppButton = true;
        }
      } else if (hasPaidProduct.paymentStatus === "Cancelled") {
        isDetailButton = false;
        if (
          isCurrentDateEqualOrLessThanGivenDate(hasPaidProduct.expireDate || "")
        ) {
          isOpenAppButton = true;
        } else {
          IsPayNowButton = true;
        }
      } else {
        IsPayNowButton = true;
      }
      if (isAdmin) {
        isDetailButton = true;
      }
    } else {
      IsPayNowButton = true;
    }
    return (
      <div className="w-64 flex flex-row space-x-2">
        {isDetailButton && (
          <Button
            title="Detail" // TODO: translate
            onClickHandler={() => {
              goToDetailPage(item, hasPaidProduct!);
            }}
          />
        )}
        {/* {IsPayNowButton && (
                    <Button
                        title="Paga ora"
                        onClickHandler={() => {
                            handlePayNowClick(item, hasPaidProduct!);
                        }}
                    />
                )} */}
        {isOpenAppButton && (
          <Button
            title="Apri l'app"
            onClickHandler={() => {
              openAppPage(item.appUrl);
            }}
          />
        )}
      </div>
    );
  };
  return (
    <div>
      {productList?.map((item: Product) => (
        <div className="table-row" key={item.id}>
          <div className={`table-data col-xs-4${userRole === 0 ? "4" : "6"}`}>
            {item.name}
          </div>
          {userRole === 0 && (
            <div className="table-data col-xs-4">{item.appCode}</div>
          )}
          <div className={`table-data col-xs-4${userRole === 0 ? "4" : "6"}`}>
            <span className="font-bold">{item.price} &euro;</span> / Per
            articolo
          </div>
          <div
            className={`col-xs-6${
              userRole === 0 ? "4" : "6"
            } flex justify-center`}
          >
            <div className="w-64 flex flex-row space-x-2">
              {userInfo.role === 0 && getActionsButtons(item)}
              {!(userInfo.role === 0) && getActionsButtons(item, true)}
            </div>
          </div>
        </div>
      ))}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-70 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg shadow-lg transition-transform transform scale-100 hover:scale-105">
            <h2 className="text-2xl font-bold mb-4 text-indigo-600">
              Conferma Pagamento
            </h2>
            <p className="mb-4 text-gray-700">
              Assicurati di leggere le informazioni prima di procedere con il
              pagamento.
            </p>
            <div className="my-4 flex items-center">
              <label htmlFor="terms-checkbox" className="text-gray-700">
                <input
                  type="checkbox"
                  id="terms-checkbox"
                  className="mr-2 h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                Accept terms and conditions
              </label>
            </div>
            <div className="flex justify-end space-x-4">
              <Button title="CANCEL" onClickHandler={handlePopupClose} />
              <Button
                title="CONTINUE"
                onClickHandler={handleContinue}
                disabled={!isChecked}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductActions;
